/* eslint-disable no-explicit-any, @typescript-eslint/no-explicit-any */
var debounce = function (callback, wait) {
    if (wait === void 0) { wait = 250; }
    var timer; // for browser probably should be `number | undefined`
    var lastCall = 0;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        var now = Date.now();
        var timeFromLastCall = now - lastCall;
        if (timeFromLastCall > wait) {
            lastCall = now;
            callback.apply(void 0, args);
        }
        else {
            timer = setTimeout(function () {
                lastCall = now;
                callback.apply(void 0, args);
            }, wait);
        }
    };
};
export default debounce;
